export default "__VITE_ASSET__7e5d339b__"